import { render, staticRenderFns } from "./GamesFilteredBox.vue?vue&type=template&id=076a159c&scoped=true&lang=pug&"
import script from "./GamesFilteredBox.vue?vue&type=script&lang=js&"
export * from "./GamesFilteredBox.vue?vue&type=script&lang=js&"
import style0 from "./GamesFilteredBox.vue?vue&type=style&index=0&id=076a159c&scoped=true&lang=css&"
import style1 from "./GamesFilteredBox.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../.yarn/$$virtual/vue-loader-virtual-5d68b12ba1/0/cache/vue-loader-npm-15.9.0-dfd6801660-2.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076a159c",
  null
  
)

export default component.exports